<template>
    <div class="header-container">
        <div class="logo-container">
            <img v-if="this.isProd === true" class="project-logo" src="../images/logo.svg" alt="fire ant">
            <div class="project-title-container">
                <img v-if="this.isProd === true" class="project-name-header-img" src="../images/page_name.svg"
                     alt="project name">
                <div v-else class="page-name-test">测试</div>
            </div>
            <div class="my-wallet-address">{{ myWalletAddressDisplay }}</div>
        </div>
        <img class="menu-btn" src="../images/menu.svg" alt="menu" @click="onMenuClick">
    </div>
    <Teleport to="body">
        <transition name="slide-right">
            <MenuComponent v-if="this.showMenu === true" @close="onMenuClose"></MenuComponent>
        </transition>
    </Teleport>
</template>
<script>
import MenuComponent from "@/components/MenuComponent.vue";
import {maskBscAddress, toChecksumAddress} from "@/utils/web3Helper";
import {isProd} from "@/utils/constants";

export default {
    name: 'HeaderComponent',
    emits: ['close'], // 添加这行
    props: {
        msg: String
    },
    components: {
        MenuComponent
    },
    inject: ['langStore', 'localize'],
    data() {
        return {
            showMenu: false,
            isProd // 将 isProd 添加到 data 中
        }
    },
    async mounted() {
    },
    computed: {
        myWalletAddressDisplay() {
            if (!this.$store.state.connectedWallet) {
                return null
            }
            return maskBscAddress(toChecksumAddress(this.$store.state.connectedWallet))
        }
    },
    methods: {
        onMenuClick() {
            this.showMenu = true
        },
        onMenuClose() {
            this.showMenu = false
        }
    }
}
</script>
<style scoped>
.header-container {
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    z-index: 1;
    font-size: 1em;
    padding: 0.8em;
    box-sizing: border-box;
    background-color: #090600;
    gap: 0.6em;
}

.logo-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.8em;
    flex: 1;
    justify-content: space-between;
}

.project-title {
    font-size: 2.8em;
    color: #ffffff;
}

.project-logo {
    width: auto;
    height: 5em;
}

.menu-btn {
    width: 3em;
}

.project-title-container {
    display: flex;
    flex-direction: column;
    align-items: start;
}

.project-title-en {
    font-size: 1.4em;
    color: #ffffff;
}

.project-name-header-img {
    height: 1.8em;
}

.my-wallet-address {
    color: #dadada;
    font-size: 1.2em;
    border: 1px solid #dadada;
    padding: 0.2em;
    box-sizing: border-box;
    line-height: 1.2em;
    border-radius: 0.2em;
}

.page-name-test {
    color: #ffffff;
    font-size: 2.4em;
}
</style>
